import React from 'react'
import { CreateAndBuildProvider } from './Context'
import type { CreateAndBuildProps } from '@ztechapps/webui.contract'
import { Layout } from './Layout'

export const CreateAndBuild = (props: CreateAndBuildProps) => {
  return (
    <CreateAndBuildProvider {...props}>
      <Layout />
    </CreateAndBuildProvider>
  )
}
